@if (!editMode) {
  <div>
    <!--class="cut-text"-->
    <a
      href="{{ hrefData }}"
      onclick="
        window.open(
          this.href,
          'targetWindow',
          'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=375,height=812'
        );
        return false;
      ">
      {{ data }}
    </a>
  </div>
}
